import { render, staticRenderFns } from "./Preview_default.vue?vue&type=template&id=380ab6e8&scoped=true&"
import script from "./Preview_default.vue?vue&type=script&lang=js&"
export * from "./Preview_default.vue?vue&type=script&lang=js&"
import style0 from "./Preview_default.vue?vue&type=style&index=0&id=380ab6e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380ab6e8",
  null
  
)

export default component.exports